import { useAPI } from './apiService';

// Create a hook to get the medChron service with the API instance
export const useMedChronService = () => {
  const api = useAPI();

  return {
    // Get complete chronology data
    getChronology: async (caseId, versionId = null) => {
      const params = versionId ? `?version_id=${versionId}` : '';
      const response = await api.get(`/chronology/${caseId}${params}`);
      return response.data;
    },

    // Get chronology versions
    getChronologyVersions: async (caseId) => {
      const response = await api.get(`/chronology/${caseId}/versions`);
      return response.data;
    },

    // Get visit types from physician's template
    getVisitTypes: async (caseId) => {
      const response = await api.get(`/visit-types/${caseId}`);
      return response.data;
    },

    // Visit operations
    createVisit: async (caseId, visitData) => {
      const response = await api.post(`/visits/${visitData.version_id}`, visitData);
      return response.data;
    },

    updateVisit: async (caseId, visitId, visitData) => {
      const response = await api.put(`/visits/${visitData.version_id}/${visitId}`, visitData);
      return response.data;
    },

    deleteVisit: async (caseId, visitId, versionId) => {
      const response = await api.delete(`/visits/${versionId}/${visitId}`);
      return response.data;
    },

    // Visit detail operations
    addVisitDetail: async (caseId, visitId, detailData) => {
      const response = await api.post(`/visits/${detailData.version_id}/${visitId}/details`, detailData);
      return response.data;
    },

    updateVisitDetail: async (caseId, visitId, oldCategory, detailData) => {
      const response = await api.put(`/visits/${detailData.version_id}/${visitId}/details/${oldCategory}`, detailData);
      return response.data;
    },

    deleteVisitDetail: async (caseId, visitId, category, versionId) => {
      const response = await api.delete(`/visits/${versionId}/${visitId}/details/${category}`);
      return response.data;
    },

    // Summary operations
    updateSummary: async (caseId, field, value) => {
      const response = await api.put(`/summary/${caseId}`, { field, value });
      return response.data;
    },

    updateVersionName: async (versionId, versionName) => {
      const response = await api.put(`/chronology/versions/${versionId}/name`, { version_name: versionName });
      return response.data;
    },

    setVersionAsCurrent: async (versionId) => {
      const response = await api.put(`/chronology/versions/${versionId}/set-current`);
      return response.data;
    },
  };
}; 